import { render } from "./getServer.vue?vue&type=template&id=3bbc37d7&scoped=true"
import script from "./getServer.vue?vue&type=script&lang=js"
export * from "./getServer.vue?vue&type=script&lang=js"

import "./getServer.vue?vue&type=style&index=0&id=3bbc37d7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bbc37d7"]])

export default __exports__